<template>
  
    <div class="content">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12">
                <h4>Hai,</h4>
                <h2 class="m-0">{{myGlobal.Session('nama')}}</h2>
                <div class="box-horizontal mb-4">
                  <i class="material-icons">phone</i>
                  <span class="h4 m-0 ml-2">{{myGlobal.Session('wa')}}</span>
                </div>
                <div class="card pt-2 pb-2 pl-3 pr-3">
                  <div class="box-horizontal m-0">
                    <i class="material-icons text-info">account_balance_wallet</i>
                    <div class="ml-2 flex-1">
                      <span class="h4 m-0 d-block">Pembayaran Diterima</span>
                      <span class="h3 m-0 text-info">{{myGlobal.ribu(total.data.invoice)}}</span>
                    </div>
                      <router-link :to="{ name: 'invoice' }"  class="text-info pointer" > Detail >></router-link>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="row">
              <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="card card-stats">
                  <div class="card-header card-header-warning card-header-icon">
                    <div class="card-icon">
                      <i class="material-icons">content_copy</i>
                    </div>
                    <p class="card-category">Belum Bayar</p>
                    <h3 class="card-title">{{total.data.belum}}</h3>
                  </div>
                  <div class="card-footer">
                    <div class="col-md-6">
                    </div>
                    <div class="col-md-6 text-right">
                      <router-link :to="{ name: 'pelanggan-belum' }"  class="text-info" > Detail >></router-link>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="card card-stats">
                  <div class="card-header card-header-danger card-header-icon">
                    <div class="card-icon">
                      <i class="material-icons">build</i>
                    </div>
                    <p class="card-category">Pengaduan</p>
                    <h3 class="card-title">{{total.data.pengaduan}}</h3>
                  </div>
                  <div class="card-footer">
                     <router-link :to="{ name: 'pengaduan' }"  class="text-info" > Detail >></router-link> 
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="card card-stats">
                  <div class="card-header card-header-info card-header-icon">
                    <div class="card-icon">
                      <i class="material-icons">push_pin</i>
                    </div>
                    <p class="card-category">Tugas Teknisi</p>
                    <h3 class="card-title">{{total.data.tugas}}</h3>
                  </div>
                  <div class="card-footer">
                    <router-link :to="{ name: 'tugas' }"  class="text-info" > Detail >></router-link>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="row">
                <div class="col-md-6">
                  <div class="card">
                    <div class="card-header card-header-info">
                      <h4 class="card-title ">Daftar Pembayaran</h4>
                      <p class="card-category">Berikut daftar Pembayaran 'Per Hari ini'</p>
                    </div>
                    <div class="card-body">
                      <div class="table-responsive">
                        <table class="table">
                          <thead class=" text-info">
                            <th width="30px">No.</th>
                            <th>Nama</th>
                            <th>Area</th>
                            <th>Iuran</th>
                            <th>By</th>
                            <th width="100px">Aksi</th>
                            <th></th>
                          </thead>
                          <tbody>
                            <tr v-for="(ser, index) in transaksi.data.orderan">
                              <td>{{ index+1 }}</td>
                              <td>{{ ser.user.unama }}</br>{{ ser.user.wa }}</td>
                              <td>{{ ser.area }}</td>
                              <td>{{ myGlobal.ribu(ser.user.paket_tarif) }}</td>
                              <td>{{ ser.user.by_admin }}</td>
                              <td>
                                <router-link :to="{ name: 'pelanggan-detail', params: { id: ser.user.uid, nama:ser.user.unama, wa:ser.user.wa, tgl:ser.user.tanggal_tagihan, paket:ser.user.paket_nama, bayar:ser.user.tarif, area:ser.area  }}"  class="text-info" ><i class="material-icons">remove_red_eye</i> Detail</router-link>
                              </td>
                            </tr>
                          </tbody>
                          <tbody v-if="transaksi.data.orderan.length == 0">
                            <td></td>
                            <td>Tidak ada data</td>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="card">
                    <div class="card-header card-header-warning">
                      <h4 class="card-title ">Daftar Tugas Teknisi</h4>
                      <p class="card-category">Berikut daftar Tugas Pending dan Proses Teknisi</p>
                    </div>
                    <div class="card-body">
                      <div class="table-responsive">
                        <table class="table">
                          <thead class=" text-info">
                            <th width="30px">No.</th>
                            <th>Nomor</th>
                            <th>Proses Oleh</th>
                            <th>Status</th>
                            <th>Pelanggan</th>
                          </thead>
                          <tbody>
                            <tr v-for="(d, index) in total.data.tugasList" class="pointer">
                              <td>{{ index+1 }}</td>
                              <td class="text-info">Tugas #{{ d.fake_id }}</td>
                              <td>{{ d.proses_oleh }}</td>
                              <td>
                                <span class="text-warning" v-if="d.status == 'pending'">PENDING</span>
                                <span class="text-info" v-else-if="d.status == 'proses'">PROSES</span>
                                <span class="text-success" v-else>SELESAI</span>
                              </td>
                              <td>{{ d.unama }}</br>{{ d.wa }}</td>
                              <!--
                              <td>{{ ser.area }}</td>
                              <td>{{ myGlobal.ribu(ser.user.paket_tarif) }}</td>
                              <td>{{ ser.user.by_admin }}</td>
                              <td>
                                <router-link :to="{ name: 'pelanggan-detail', params: { id: ser.user.uid, nama:ser.user.unama, wa:ser.user.wa, tgl:ser.user.tanggal_tagihan, paket:ser.user.paket_nama, bayar:ser.user.tarif, area:ser.area  }}"  class="text-info" ><i class="material-icons">remove_red_eye</i> Detail</router-link>
                              </td>
                              -->
                            </tr>
                          </tbody>
                          <tbody v-if="total.data.tugasList.length == 0">
                            <td></td>
                            <td></td>
                            <td>Tidak ada data</td>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
            </div>

            <!--
            <div class="row">
              <div class="col-md-12">
                <div class="alert alert-info" role="alert">
                  Rumus Hitung >> <strong>Total Pelanggan = Belum Bayar + Isolir + Baru Belum Bayar + Lunas Bayar.</strong> Untuk Pelanggan baru sudah bayar itu sudah masuk ke dalam Lunas Bayar
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="card card-stats">
                  <div class="card-header card-header-secondary card-header-icon">
                    <div class="card-icon">
                      <i class="material-icons">content_copy</i>
                    </div>
                    <p class="card-category">Pelanggan</p>
                    <h3 class="card-title">{{total.data.user}}</h3>
                  </div>
                  <div class="card-footer">
                    <div class="col-md-6">
                      <p class="mb-0"><strong>{{myGlobal.ribu(total.data.userUang)}}</strong></p>
                    </div>
                    <div class="col-md-6 text-right">
                      <router-link :to="{ name: 'pelanggan' }"  class="text-info" > Detail >></router-link>
                    </div>
                    
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="card card-stats">
                  <div class="card-header card-header-warning card-header-icon">
                    <div class="card-icon">
                      <i class="material-icons">content_copy</i>
                    </div>
                    <p class="card-category">Belum Bayar</p>
                    <h3 class="card-title">{{total.data.belum}}</h3>
                  </div>
                  <div class="card-footer">
                    <div class="col-md-6">
                      <p class="mb-0"><strong>{{myGlobal.ribu(total.data.belumUang)}}</strong></p>
                    </div>
                    <div class="col-md-6 text-right">
                      <router-link :to="{ name: 'belum' }"  class="text-info" > Detail >></router-link>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="card card-stats">
                  <div class="card-header card-header-danger card-header-icon">
                    <div class="card-icon">
                      <i class="material-icons">people</i>
                    </div>
                    <p class="card-category">Isolir</p>
                    <h3 class="card-title">{{total.data.isolir}}</h3>
                  </div>
                  <div class="card-footer">
                    <router-link :to="{ name: 'pelanggan-isolir' }"  class="text-info" > Detail >></router-link>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="row">
              <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="card card-stats">
                  <div class="card-header card-header-info card-header-icon">
                    <div class="card-icon">
                      <i class="material-icons">people</i>
                    </div>
                    <p class="card-category">Plgn Baru Tapi Belum Bayar</p>
                    <h3 class="card-title">{{total.data.baruPaid}}</h3>
                  </div>
                  <div class="card-footer">
                    <router-link :to="{ name: 'pelanggan', params: { filter:'new' } }"  class="text-info" > Detail >></router-link>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="card card-stats">
                  <div class="card-header card-header-info card-header-icon">
                    <div class="card-icon">
                      <i class="material-icons">people</i>
                    </div>
                    <p class="card-category">Plgn Baru Tapi Sudah Bayar (Prorata)</p>
                    <h3 class="card-title">{{total.data.baruPaid}}</h3>
                  </div>
                  <div class="card-footer">
                    <router-link :to="{ name: 'pelanggan', params: { filter:'new' } }"  class="text-info" > Detail >></router-link>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="card card-stats">
                  <div class="card-header card-header-success card-header-icon">
                    <div class="card-icon">
                      <i class="material-icons">check</i>
                    </div>
                    <p class="card-category">Lunas</p>
                    <h3 class="card-title">{{total.data.lunas}}</h3>
                  </div>
                  <div class="card-footer">
                    <div class="col-md-6">
                      <p class="mb-0"><strong>{{myGlobal.ribu(total.data.lunasUang)}}</strong></p>
                    </div>
                    <div class="col-md-6 text-right">
                      <router-link :to="{ name: 'lunas' }"  class="text-info" > Detail >></router-link>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="card card-stats">
                  <div class="card-header card-header-success card-header-icon">
                    <div class="card-icon">
                      <i class="material-icons">check</i>
                    </div>
                    <p class="card-category">Transaksi Cash</p>
                    <h3 class="card-title">{{total.data.lunasCash}}</h3>
                  </div>
                  <div class="card-footer">
                    <div class="col-md-6">
                      <p class="mb-0"><strong>{{myGlobal.ribu(total.data.lunasCashUang)}}</strong></p>
                    </div>
                    <div class="col-md-6 text-right">
                      <router-link :to="{ name: 'lunas' }"  class="text-info" > Detail >></router-link>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="card card-stats">
                  <div class="card-header card-header-success card-header-icon">
                    <div class="card-icon">
                      <i class="material-icons">check</i>
                    </div>
                    <p class="card-category">Transaksi Online</p>
                    <h3 class="card-title">{{total.data.lunasOnline}}</h3>
                  </div>
                  <div class="card-footer">
                    <div class="col-md-6">
                      <p class="mb-0"><strong>{{myGlobal.ribu(total.data.lunasOnlineUang)}}</strong></p>
                    </div>
                    <div class="col-md-6 text-right">
                      <router-link :to="{ name: 'lunas' }"  class="text-info" > Detail >></router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="card card-stats">
                  <div class="card-header card-header-info card-header-icon">
                    <div class="card-icon">
                      <i class="material-icons">people</i>
                    </div>
                    <p class="card-category">Pemasangan Baru</p>
                    <h3 class="card-title">{{total.data.baru}}</h3>
                  </div>
                  <div class="card-footer">
                    <router-link :to="{ name: 'pelanggan', params: { filter:'new' } }"  class="text-info" > Detail >></router-link>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="card card-stats">
                  <div class="card-header card-header-danger card-header-icon">
                    <div class="card-icon">
                      <i class="material-icons">close</i>
                    </div>
                    <p class="card-category">Berhenti</p>
                    <h3 class="card-title">{{total.data.userBerhenti}}</h3>
                  </div>
                  <div class="card-footer">
                    <router-link :to="{ name: 'pelanggan', params: { filter:'new' } }"  class="text-info" > Detail >></router-link>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-show="false">
                <div class="col-md-12">
                  <div class="alert alert-success" role="alert">
                    <p>CATATAN FITUR YG PENDING</p>
                    <p>WEB</p>
                    <p>- edit area penagih</p>
                    <p>- Pilih Bulan Default All Data</p>
                    <p>- history pelanggan filter area ga kenek</p>
                  </div>
                </div>
            </div>
            -->
        </div>
      </div>
</template>

<script>
import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 

import { RedisSession } from '@/globalFunc/redis'

import moment from 'moment'

Vue.use(moment)

export default {
  name: 'Beranda', 
  components: { 
    vuejsDatepicker,
    moment
  },
	setup() {
		const data = reactive({
			tahunBase: '',
			bulanBase: '',
		})
		const transaksi = { 
			data: reactive({
        orderan: [],
			}),
			getData() {
        
        let cacheT = "dash_transaksi"; // REDIS ====================================
        const cached = RedisSession.get(cacheT);
        if (cached) {
            let x = cached;

            if (x.status) {
              var data = x.data;
              transaksi.data.orderan = data;
            }

            // LANJUT DI BAWAH

            myGlobal.loger("dari radis "+cacheT);

            return false;
        }
        myGlobal.loger("baru "+cacheT);

        var data = {
          token: 'TangTung '+sessionStorage.getItem('myToken')
        }
				
				var apiUrl = 'content/transaksi/transaksi-today';
				
				myGlobal.call(data,apiUrl).then(x => {
					//myGlobal.loger(x);
          RedisSession.set(cacheT, x, 600000); // 10 menit

					if (x.status) {
            var data = x.data;
            transaksi.data.orderan = data;
					}

				})
			}
    }
    
		const total = { 
			data: reactive({
        user: '-',
        userBerhenti: '-',
        userUang: '-',
        belum: '-',
        belumUang: '-',
        lunas: '-',
        lunasUang: '-',
        baru: '-',
        baruPaid: '-',
        baruUnPaid: '-',
        lunasOnlineUang: '-',
        lunasCashUang: '-',
        lunasCash: '-',
        lunasOnline: '-',
        isolir: '-',

        pengaduan: 0,
        tugas: 0,
        invoice: 0,
        tugasList: []
			}),
			getPPN() {

        let cacheT = "dash_ppn";
        const cached = RedisSession.get(cacheT);
        if (cached) {
            let x = cached;
            
            if (x.status) {
              var data = x.data;
              // PPN
              sessionStorage.setItem('PPN', data.ppn);
            }

            myGlobal.loger("dari radis "+cacheT)

            return false;
        }

        myGlobal.loger("baru "+cacheT)

        var datax = {
          token: 'TangTung '+sessionStorage.getItem('myToken')
        }
				
				var apiUrl = inter.Ppn();
				myGlobal.call(datax,apiUrl).then(x => {
					//myGlobal.loger(x);
          // 1. Cek di "Redis" lokal dulu
          
          RedisSession.set(cacheT, x, 300000);

					if (x.status) {
            var data = x.data;
            // PPN
            sessionStorage.setItem('PPN', data.ppn);
					}

          //total.getData();

				})
      },
			getData() {
        /*
        var datax = new FormData();
        datax.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
        datax.append('bulan', myGlobal.getBulan());
        datax.append('tahun', myGlobal.getTahunNow());

        var datax = {
          token: 'TangTung '+sessionStorage.getItem('myToken'),
          bulan: myGlobal.getBulan(),
          tahun: myGlobal.getTahunNow()
        }

				var apiUrl = inter.BerandaPPOE();
				
				myGlobal.call(datax,apiUrl).then(x => {

					//myGlobal.loger(x);

					if (x.status == true) {
            var datax = x.data;
            
            total.data.belum = datax.belum;

            alert(datax.pengaduan);
            
					}
				})
        */
			},
			getInvoice() {
        let cacheT = "dash_inv"; // REDIS ============================================
        const cached = RedisSession.get(cacheT);
        if (cached) {
            let x = cached;

            // LANJUT DI BAWAH
            if (x.status == true) {
              var datax = x.data;

              total.data.invoice = datax.saldo_after;
              
            }

            myGlobal.loger("dari radis "+cacheT);

            return false;
        }
        myGlobal.loger("baru "+cacheT)
        
        var datax = {
          token: 'TangTung '+sessionStorage.getItem('myToken')
        }
				var apiUrl = inter.getInvoice();
				
				myGlobal.call(datax,apiUrl).then(x => {

          RedisSession.set(cacheT, x, 300000);

					if (x.status == true) {
            var datax = x.data;

            total.data.invoice = datax.saldo_after;
            
					}
				})
			},
			getBeranda() {

        let berandaData = sessionStorage.getItem("beranda-data");

        if(berandaData != null) {

          berandaData = JSON.parse(berandaData);

          var data = berandaData.data;

          total.data.pengaduan = data.pengaduan;
          total.data.belum = data.belum;
          
          sessionStorage.setItem('myInfoPrint', data.info);
          sessionStorage.setItem('logo', data.logo);
          sessionStorage.setItem('PPN', data.ppn);
          sessionStorage.setItem('wateks', data.wa);
          sessionStorage.setItem('infoTeks', data.info);
          sessionStorage.setItem('supportby', data.support);
          sessionStorage.setItem('prefix', data.prefix);

          total.getTugas();
          total.getInvoice();
          
        } else {
          // data beranda belum ada

          let ndasmu = this;
          
          setTimeout(
            function() {
              ndasmu.getBeranda();
            }
          , 2000);

        }

        /*
        var datax = {
          token: 'TangTung '+sessionStorage.getItem('myToken'),
          bulan: myGlobal.getBulan(),
          tahun: myGlobal.getTahunNow()
        }


				var apiUrl = "beranda";
				
				myGlobal.call(datax,apiUrl).then(x => {

        console.log(JSON.stringify(x))


					if (x.status == true) {
            var data = x.data;

            total.data.pengaduan = data.pengaduan;
            total.data.belum = data.belum;

            // PPN
            sessionStorage.setItem('myInfoPrint', data.info);
            sessionStorage.setItem('logo', data.logo);
            sessionStorage.setItem('PPN', data.ppn);
            sessionStorage.setItem('wateks', data.wa);
            sessionStorage.setItem('infoTeks', data.info);
            sessionStorage.setItem('supportby', data.support);
            sessionStorage.setItem('prefix', data.prefix);

            total.getTugas();
            total.getInvoice();


					}
				})
          */
			},
      getTugas() {
        // TAGIHAN_HARI_INI =============================================================================================
        
        let cacheT = "dash_tugas";
        const cached = RedisSession.get(cacheT);
        if (cached) {
            let x = cached;

            // LANJUT DI BAWAH
            if (x.status == true) {
              total.data.tugas = x.data.length;
              total.data.tugasList = x.data;
            }

            myGlobal.loger("dari radis "+cacheT);

            return false;
        }
        myGlobal.loger("baru "+cacheT);


        var datax = {
          token: 'TangTung '+myGlobal.Session("token"),
          status: 'pending-proses'
        }

				var apiUrl = inter.TugasTeknisiList();
				
				myGlobal.call(datax,apiUrl).then(x => {
					//myGlobal.loger(x); 

          RedisSession.set(cacheT, x, 600000); // 10 menit

					if (x.status == true) {
            total.data.tugas = x.data.length;
            total.data.tugasList = x.data;
					}
          
				})
      }
		}

		return {
			myGlobal,
      data,
      transaksi,
      total
		}
  },
	mounted() {
    this.data.tahunBase = myGlobal.getTahunNow();
    this.data.bulanBase = myGlobal.getBulan();

    this.transaksi.getData();
    this.total.getPPN();


    this.total.getBeranda();

    //this.total.getData();
	}
  /*
  methods: {
    getData() {
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('bulan', '0');
      
      var apiUrl = 'beranda';
      this.PostData(data,apiUrl).then(x => {
        if (x.status) {
          var data = x.data;
          this.user = data.user;
          this.belum = data.belum;
          this.lunas = data.lunas;
        } else {
          //alert(x.pesan);
        }
      })
    }
  }
  */
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.card-icon {
  padding: 5px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Main.vue